"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsurerParticipants = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const insurer_entity_1 = require("./insurer.entity");
const final_negotiation_meeting_summary_entity_1 = require("./final-negotiation-meeting-summary.entity");
let InsurerParticipants = class InsurerParticipants {
    constructor(id, meetingSummaryId, insurerId, sharePercentage, brokeragePercentage, brokerageAmount) {
        this.id = id;
        this.meetingSummaryId = meetingSummaryId;
        this.insurerId = insurerId;
        this.sharePercentage = sharePercentage;
        this.brokeragePercentage = brokeragePercentage;
        this.brokerageAmount = brokerageAmount;
    }
};
exports.InsurerParticipants = InsurerParticipants;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id" }),
    tslib_1.__metadata("design:type", Number)
], InsurerParticipants.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "meeting_summary_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], InsurerParticipants.prototype, "meetingSummaryId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], InsurerParticipants.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "share_percentage", type: "decimal", precision: 5, scale: 2 }),
    tslib_1.__metadata("design:type", Number)
], InsurerParticipants.prototype, "sharePercentage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "brokerage_percentage",
        type: "decimal",
        precision: 5,
        scale: 2,
    }),
    tslib_1.__metadata("design:type", Number)
], InsurerParticipants.prototype, "brokeragePercentage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "brokerage_amount",
        type: "decimal",
        precision: 10,
        scale: 2,
    }),
    tslib_1.__metadata("design:type", Number)
], InsurerParticipants.prototype, "brokerageAmount", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => final_negotiation_meeting_summary_entity_1.FinalNegotiationMeetingSummary, (meeting) => meeting.insurerShares),
    (0, typeorm_1.JoinColumn)({ name: "meeting_summary_id" }),
    tslib_1.__metadata("design:type", Object)
], InsurerParticipants.prototype, "meetingSummary", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => insurer_entity_1.Insurer),
    (0, typeorm_1.JoinColumn)({ name: "insurer_id" }),
    tslib_1.__metadata("design:type", Object)
], InsurerParticipants.prototype, "insurer", void 0);
exports.InsurerParticipants = InsurerParticipants = tslib_1.__decorate([
    (0, typeorm_1.Entity)("insurer_participant_map"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, Number, Number, Number])
], InsurerParticipants);
